import React, { useEffect } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Alert from "../ui/Alert";
import TextButton from "../ui/TextButton";
import { kbdEvent } from "../utils/Utils";

export default function Info(props) {

    const { controller = "", route = "", events = [], callback = () => { }, title = "Info", description = "", buttons = false, type = "info" } = props;

    // Pass in keyboard events that get passed back to the callback...

    useEffect(() => {
        const actions = [
            { key: KBD.ANY, action: (e) => { callback(false) } },
        ];
        const cleanup = listen(controller, route, actions.concat(events.map(item => {
            return { key: item, action: (e) => { callback(item) } }
        })), false);
        return cleanup;
    }, []);



    return (<>
        <Alert
            title={title}
            dismissible
            type={type}
            callback={callback}
            description={<>
                {description}
                {(buttons && <div style={{ "margin": "0 auto", "width": "200px", "textAlign": "center" }}>
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <TextButton onClick={() => kbdEvent(KBD.ANY)}>Press any key to continue</TextButton>
                </div>
                )}
            </>}
        />
    </>)
}